module.exports = __webpack_public_path__ + "img/infograph_4.7319e877.png";